"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TurnIntoDropdownMenu = TurnIntoDropdownMenu;
var _react = _interopRequireDefault(require("react"));
var _plateCommon = require("@udecode/plate-common");
var _plateHeading = require("@udecode/plate-heading");
var _plateParagraph = require("@udecode/plate-paragraph");
var _ri = require("react-icons/ri");
var _dropdownMenu = require("./dropdown-menu");
var _toolbar = require("./toolbar");
var _jsxRuntime = require("react/jsx-runtime");
var items = [{
  description: 'Paragraph',
  icon: _ri.RiParagraph,
  label: 'Paragraph',
  value: _plateParagraph.ELEMENT_PARAGRAPH
}, {
  description: 'Heading 1',
  icon: _ri.RiH1,
  label: 'Heading 1',
  value: _plateHeading.ELEMENT_H1
}, {
  description: 'Heading 2',
  icon: _ri.RiH2,
  label: 'Heading 2',
  value: _plateHeading.ELEMENT_H2
}, {
  description: 'Heading 3',
  icon: _ri.RiH3,
  label: 'Heading 3',
  value: _plateHeading.ELEMENT_H3
}
// {
// 	description: 'Quote (⌘+⇧+.)',
// 	icon: Icons.blockquote,
// 	label: 'Quote',
// 	value: ELEMENT_BLOCKQUOTE,
// },
// {
//   value: 'ul',
//   label: 'Bulleted list',
//   description: 'Bulleted list',
//   icon: Icons.ul,
// },
// {
//   value: 'ol',
//   label: 'Numbered list',
//   description: 'Numbered list',
//   icon: Icons.ol,
// },
];
var defaultItem = items.find(function (item) {
  return item.value === _plateParagraph.ELEMENT_PARAGRAPH;
});
function TurnIntoDropdownMenu(props) {
  var _items$find;
  var value = (0, _plateCommon.useEditorSelector)(function (editor) {
    var initialNodeType = _plateParagraph.ELEMENT_PARAGRAPH;
    var allNodesMatchInitialNodeType = false;
    var codeBlockEntries = (0, _plateCommon.getNodeEntries)(editor, {
      match: function match(n) {
        return (0, _plateCommon.isBlock)(editor, n);
      },
      mode: 'highest'
    });
    var nodes = Array.from(codeBlockEntries);
    if (nodes.length > 0) {
      initialNodeType = nodes[0][0].type;
      allNodesMatchInitialNodeType = nodes.every(function (_ref) {
        var _ref3 = _slicedToArray(_ref, 1),
          node = _ref3[0];
        var type = (node === null || node === void 0 ? void 0 : node.type) || _plateParagraph.ELEMENT_PARAGRAPH;
        return type === initialNodeType;
      });
    }
    return allNodesMatchInitialNodeType ? initialNodeType : _plateParagraph.ELEMENT_PARAGRAPH;
  }, []);
  var editor = (0, _plateCommon.useEditorRef)();
  var openState = (0, _dropdownMenu.useOpenState)();
  var selectedItem = (_items$find = items.find(function (item) {
    return item.value === value;
  })) !== null && _items$find !== void 0 ? _items$find : defaultItem;
  var SelectedItemIcon = selectedItem.icon,
    selectedItemLabel = selectedItem.label;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenu, _objectSpread({
    modal: false
  }, openState, props, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuTrigger, {
      asChild: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_toolbar.ToolbarButton, {
        className: !props.compact ? 'min-w-[130px]' : '',
        isDropdown: true,
        pressed: openState.open,
        tooltip: "Turn into",
        children: [props.compact && /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectedItemIcon, {
          className: "p-0.5 size-4"
        }), !props.compact && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: selectedItemLabel
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenuContent, {
      align: "start",
      className: "min-w-0 plate-editor-wrapper",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuLabel, {
        children: "Turn into"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdownMenu.DropdownMenuRadioGroup, {
        className: "flex flex-col gap-0.5",
        onValueChange: function onValueChange(type) {
          // if (type === 'ul' || type === 'ol') {
          //   if (settingsStore.get.checkedId(KEY_LIST_STYLE_TYPE)) {
          //     toggleIndentList(editor, {
          //       listStyleType: type === 'ul' ? 'disc' : 'decimal',
          //     });
          //   } else if (settingsStore.get.checkedId('list')) {
          //     toggleList(editor, { type });
          //   }
          // } else {
          //   unwrapList(editor);
          (0, _plateCommon.toggleNodeType)(editor, {
            activeType: type
          });
          // }

          (0, _plateCommon.collapseSelection)(editor);
          (0, _plateCommon.focusEditor)(editor);
        },
        value: value,
        children: items.map(function (_ref2) {
          var Icon = _ref2.icon,
            label = _ref2.label,
            itemValue = _ref2.value;
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dropdownMenu.DropdownMenuRadioItem, {
            className: "min-w-[180px]",
            value: itemValue,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
              className: "p-0.5 mr-2 size-5"
            }), label]
          }, itemValue);
        })
      })]
    })]
  }));
}